export default function Spinner() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-light-bg dark:bg-dark-bg">
      <div
        className="w-8 h-8 border-2 border-t-transparent rounded-full animate-spin"
        style={{
          borderColor: "var(--color-primary,#75350e)",
          borderTopColor: "transparent",
        }}
      />
    </div>
  );
}
